@if (timeRemaining(); as timeRemaining) {
  <div class="wrapper">
    <div class="left-section alg-flex-1">
      <i
        class="left-icon alg-secondary-color ph-duotone ph-timer"
      ></i>
      <span class="title">
        <span class="alg-secondary-color">{{ timeRemaining | asCountdown }}</span>
      </span>
    </div>
  </div>
}
